// Plain text from rich-text HTML: tags become spaces, entities (&nbsp;,
// &amp;, ...) are decoded and whitespace collapsed. DOMParser documents are
// inert, so nothing in the HTML runs.
export const stripHtml = (html) => {
  if (!html) return '';
  const spaced = String(html).replace(/<[^>]+>/g, ' ');
  let text = spaced;
  if (typeof DOMParser !== 'undefined') {
    text = new DOMParser().parseFromString(spaced, 'text/html').documentElement.textContent || '';
  }
  return text.replace(/\s+/g, ' ').trim();
};

export const isFileTypeSupported = (file) => {
  switch (file.type) {
    case "image":
    case "doc":
    case "docx":
    case "pdf":
    case "xls":
    case "xlsx":
      return true;
    default:
      return false;
  }
};

export const fileExtensionFromUri = (uri) => {
  return fileNameFromUri(uri)
    .split(".")
    .pop();
};

export const fileNameFromUri = (uri) => {
  const fileName = uri
    .substring(uri.lastIndexOf("/") + 1, uri.length);
  return fileName;
};

export const fullSrcFromFile = (file) => {
  if (file.thumbnail) {
    return file.src;
  }
  return thumbnailSrcFromFile(file);
};

export const thumbnailSrcFromFile = (file) => {
  if (file.thumbnail) {
    return file.thumbnail;
  }
  const extension = fileExtensionFromUri(file.src);
  switch (extension) {
    case "xls":
    case "xlsx":
      return require("../images/xls.png");
    case "doc":
    case "docx":
      return require("../images/doc.png");
    case "pdf":
      return require("../images/pdf.png");
    case "ppt":
      return require("../images/ppt.png");
    case "pptx":
      return require("../images/pptx.png");
    case "odt":
      return require("../images/odt.png");
    case "csv":
      return require("../images/csv.png");
    case "txt":
      return require("../images/txt.png");
    case "md":
      return require("../images/md.png");
    case "rtf":
      return require("../images/rtf.png");
    default:
      return require("../images/pdf.png");
  }
};

export const thumbnailSrcImageForImage = (asset) => {
  if (asset.thumb.url) {
    return asset.thumb.url;
  }
  const extension = fileExtensionFromUri(asset.url);
  switch (extension) {
    case "xls":
    case "xlsx":
      return require("../images/xls.png");
    case "doc":
    case "docx":
      return require("../images/doc.png");
    case "pdf":
      return require("../images/pdf.png");
    case "ppt":
      return require("../images/ppt.png");
    case "pptx":
      return require("../images/pptx.png");
    case "odt":
      return require("../images/odt.png");
    case "csv":
      return require("../images/csv.png");
    case "txt":
      return require("../images/txt.png");
    case "md":
      return require("../images/md.png");
    case "rtf":
      return require("../images/rtf.png");
    default:
      return require("../images/pdf.png");
  }
};
